module.exports = __webpack_public_path__ + "media/images/projects/8-header-73de93ca86e4b58320090e6af6fb5c3a.jpg";